const FindFormForClient_query = `
    query( $name : String!,
           $clientId: Int!)
           {
              findFormForClient(name: $name,clientId: $clientId)
               {
                  formId
                  formUuid
                  name
                  approved
                  clientId
                    {
                      clientId
                      name
                      tenantId
                      {
                        tenantId
                        name
                      }    
                      
                    }
               }
            }
`;

const FormListForClient_query = `
    query( $clientId: Int!)
    {
      formListForClient(clientId: $clientId)
      {
          formId
          formUuid
          name
          clientId
          {
            clientId
            name
            termStartDate
            tenantId
            {
              tenantId
              name
            }      
          }
          approved
          createDate
          termList
          termObjectList
          {
            termId
            name
            termUuid
          }
          noOfObjects
          formObjsLastUpdate
          formObjsLastUpdateBy
          createBy
      }
    }
`;

const CopyForm_mutate = `
    mutation copyForm(
      $formId: Int!) {
        copyForm(
                  formId: $formId)
                  {
                    form
                    {
                        formId
                        formUuid
                        name
                        clientId
                        {
                          clientId
                          name
                          tenantId
                          {
                            tenantId
                            name
                          }      
                        }
                        approved
                    }
                    
                }
    }
`;

const SaveFormName_mutate = `
    mutation saveFormName(
      $name: String!
      $formId: Int!) {
      saveFormName(
        name: $name,
        formId: $formId) {
        form
        {
          formId
          formUuid
          name
          approved          
        }
      }
    }
`;

const ChangePublishStatus_mutate = `
    mutation changePublishStatus(
      $formId: Int!,
      $approved: Boolean!) {
      changePublishStatus(
        formId: $formId,
        approved: $approved) {
        form
        {
          formId
          formUuid
          name
          approved          
        }
      }
    }
`;

const DeleteForm_mutate = `
    mutation deleteForm(
      $formId: Int!,
      $clientId: Int!) {
      deleteForm(
        formId: $formId,
        clientId: $clientId) {
        form
        {
          formId
          formUuid
          name
          approved          
        }
      }
    }
`;

const CreateForm_mutate = `
    mutation createForm(
      $name: String!
      $clientId: Int!) {
      createForm(
        name: $name,
        clientId: $clientId) {
        form
        {
          formId
          formUuid
          name
          approved
          clientId
          {
            clientId
            name
            tenantId
            {
              tenantId
              name
            }    
          }
        }
      }
    }
`;

const GetFormDataByFormUuid_query = `
  query( $formUuid: String!)
  {
    getFormDataByFormUuid(formUuid: $formUuid)
    {
      formId
      formUuid
      clientId {
        clientId
        name
        tenantId {
          tenantId
          name
          contactEmail
          statesList{
            id 
            name 
            code
          }
          countriesList{
            id 
            name 
            code
          }
        }
      }
      name
      createDate
      approved
      termList
      formPreviwTerms    
    }
  }    
`;

const ClientHasPublishedForm = `query clientHasPubForm($clientId: Int!){
  clientHasPubForm(clientId: $clientId)
}`;

module.exports = {
  FIND_FORM_FOR_CLIENT_QUERY: FindFormForClient_query,
  FORM_LIST_FOR_CLIENT_QUERY: FormListForClient_query,
  CREATE_FORM_MUTATION: CreateForm_mutate,
  SAVE_FORM_NAME_MUTATION: SaveFormName_mutate,
  CHANGE_PUBLISH_STATUS_MUTATION: ChangePublishStatus_mutate,
  DELETE_FORM_MUTATION: DeleteForm_mutate,
  COPY_FORM_MUTATION: CopyForm_mutate,
  GET_FORM_DATA_BY_FORM_UUID: GetFormDataByFormUuid_query,
  CLIENT_HAS_PUBLISHED_FORM: ClientHasPublishedForm,
};
